import { nanoid } from '@reduxjs/toolkit'
import { BuiltFieldAttributes, FieldBuilderParams } from './baseFieldBuilder'

export default function statementsBuilder({ rawField }: FieldBuilderParams): Partial<BuiltFieldAttributes> {
  if (!rawField.statements?.length) {
    return {
      statements: [
        { apiCode: nanoid(4), label: '题目一', position: 0 },
        { apiCode: nanoid(4), label: '题目二', position: 1 },
        { apiCode: nanoid(4), label: '题目三', position: 2 },
      ],
    }
  }

  return {
    statements: rawField.statements?.map((label, index) => ({
      apiCode: nanoid(4),
      label,
      position: index,
    })),
  }
}
